// @flow
/* eslint-disable no-unused-vars */

import React from "react";
import {
  Form,
  Input as InputComponent,
  Radio as RadioComponent,
  Checkbox as CheckboxComponent,
  Select as SelectComponent,
  TextArea as TextAreaComponent,
  Dropdown as DropdownComponent,
  Label, Icon, Popup,
} from "semantic-ui-react";

export const ErrorPopup = ({ touched, error }) => {
  if (!(error && touched)) return null;

  return (
    <Popup
      trigger={<Icon name='warning circle' color='red'/>}
      content={error}
      size='mini'
    />
  )
};

export const WarningPopup = ({ touched, warning }) => {
  if (!(warning && touched)) return null;

  return (
    <Popup
      trigger={<Icon name='warning sign' color='orange' />}
      content={warning}
      size='mini'
    />
  )
}



export const InputField = ({ input, label, required, width, inline, meta: { touched, error, warning }, ...rest }) => (
  <Form.Field error={!!(touched && error)} required={required} width={width} inline={inline}>
    {label && <label>{label}</label>}
    <InputComponent required={required} {...input} {...rest} />
    <ErrorPopup touched={touched} error={error} />
    <WarningPopup touched={touched} warning={warning} />
  </Form.Field>
);

export const Input = ({ input, required, meta: { touched, error }, ...rest }) => (
  <InputComponent error={!!(touched && error)} required={required} {...input} {...rest} />
);

export const TextAreaField = ({
                                input,
                                label,
                                required,
                                width,
                                inline,
                                meta: { touched, error, warning },
                                ...rest
                              }) => (
  <Form.Field error={!!(touched && error)} required={required} width={width} inline={inline}>
    {label && <label>{label}</label>}
    <TextAreaComponent required={required} {...input} {...rest} />
    <ErrorPopup touched={touched} error={error} />
    <WarningPopup touched={touched} warning={warning} />
  </Form.Field>
);

export const LabelInputField = (
  { input, required, width, meta: { touched, error, warning }, ...rest }, //eslint-disable-line
) => (
  <Form.Field error={!!(touched && error)} required={required} width={width}>
    <InputComponent required={required} {...input} {...rest} />
    <ErrorPopup touched={touched} error={error} />
    <WarningPopup touched={touched} warning={warning} />
  </Form.Field>
);

export const TextArea = ({ input, required, meta: { touched, error }, ...rest }) => (
  <TextAreaComponent required={required} {...input} {...rest} />
);

// FIN-978: semantic-ui opens the menu on focus, highlights the first option while the
// field is empty and commits it on blur, so passing through a select wrote a value
// nobody chose. `selectOnBlur={false}` on every dropdown here mirrors the formik-side
// `components/fields/SelectField`; picking an option and Enter still select.
export const SelectField = (
  {
    input,
    label,
    required,
    width,
    inline,
    options,
    meta: { touched, error, warning },
    ...custom
  }) => (
  <Form.Field error={!!(touched && error)} required={required} width={width} inline={inline}>
    {label && <label>{label}</label>}
    <SelectComponent
      search
      selectOnBlur={ false }
      clearable
      value={input.value}
      required={required}
      options={options}
      onChange={(event, data) => input.onChange(data.value)}
      {...custom}
    />
    <ErrorPopup touched={touched} error={error} />
    <WarningPopup touched={touched} warning={warning} />
  </Form.Field>
);

export const Select = ({ input, required, options, meta: { touched, error }, ...rest }) => (
  <SelectComponent
    search
    selectOnBlur={ false }
    value={input.value}
    required={required}
    options={options}
    onChange={(event, data) => input.onChange(data.value)}
    {...rest}
  />
);

export const ToggleField = ({ input, label, defaultChecked, width, ...custom }) => (
  <Form.Field
    control={RadioComponent}
    toggle
    label={label}
    checked={!!input.value}
    defaultChecked={defaultChecked}
    onClick={(event, data) => input.onChange(data.checked)}
    width={width}
    {...custom}
  />
);

export const Toggle = ({ input, label, defaultChecked, ...custom }) => (
  <RadioComponent
    toggle
    label={label}
    checked={!!input.value}
    defaultChecked={defaultChecked}
    onClick={(event, data) => input.onChange(data.checked)}
    {...custom}
  />
);

export const Radio = ({ input, label, meta: { touched, error }, ...custom }) => (
  <RadioComponent
    label={label}
    checked={!!input.value}
    onClick={(event, data) => input.onChange(data.checked)}
    {...custom}
  />
);

export const RadioField = ({ input, label, width, meta: { touched, error }, ...custom }) => (
  <Form.Field
    control={RadioComponent}
    label={label}
    width={width}
    checked={!!input.value}
    onClick={(event, data) => input.onChange(data.checked)}
    {...custom}
  />
);

export const Checkbox = ({ input, label, meta: { touched, error }, ...custom }) => (
  <CheckboxComponent
    label={label}
    checked={!!input.value}
    onClick={(event, data) => input.onChange(data.checked)}
    {...custom}
  />
);

export const CheckboxField = ({ input, label, width, meta: { touched, error }, ...custom }) => (
  <Form.Field
    control={CheckboxComponent}
    label={label}
    width={width}
    checked={!!input.value}
    onClick={(event, data) => input.onChange(data.checked)}
    {...custom}
  />
);

export const RangeField = (
  {
     input,
     label,
     width,
     inline,
     min,
     max,
     required,
     meta: { touched, error, warning },
     ...rest
   }) => (
  <Form.Field error={!!(touched && error)} required={required} width={width} inline={inline}>
    <label>
      {label} : {input.value}
    </label>
    <input type="range" required={required} min={min} max={max} {...input} {...rest} />
    <ErrorPopup touched={touched} error={error} />
    <WarningPopup touched={touched} warning={warning} />
  </Form.Field>
);

export const Range = ({ input, min, max, required, meta: { touched, error }, ...rest }) => (
  <input type="range" required={required} min={min} max={max} {...input} {...rest} />
);

export const DropdownField = (
  {
    input,
    label,
    required,
    width,
    inline,
    options,
    meta: { touched, error, warning },
    ...custom
  }) => (
  <Form.Field error={!!(touched && error)} required={required} width={width} inline={inline}>
    {label && <label>{label}</label>}
    <DropdownComponent
      search
      selectOnBlur={ false }
      value={input.value}
      required={required}
      options={options}
      onChange={(event, data) => input.onChange(data.value)}
      {...custom}
    />
    <ErrorPopup touched={touched} error={error} />
    <WarningPopup touched={touched} warning={warning} />
  </Form.Field>
);

export const Dropdown = ({ input, required, options, meta: { touched, error }, ...rest }) => (
  <DropdownComponent
    search
    selectOnBlur={ false }
    value={input.value}
    required={required}
    options={options}
    onChange={(event, data) => input.onChange(data.value)}
    {...rest}
  />
);

export const UploadField = ({ label, input, required, width, inline, meta: { touched, error, warning }, ...rest }) => {
  delete input.value; //Delete value from input
  return (
    <Form.Field error={touched && error} required={required} width={width} inline={inline}>
      {label && <label>{label}</label>}
      <InputComponent type="file" {...input} {...rest} />
      <ErrorPopup touched={touched} error={error} />
      <WarningPopup touched={touched} warning={warning} />
    </Form.Field>
  );
};

export const Upload = ({ input, required, meta: { touched, error }, ...rest }) => {
  delete input.value;
  return <InputComponent required={required} type="file" {...input} {...rest} />;
};
